// replace domain name whether coming from api instead of url
const domainName = window.location.host

export default domainName